import { render, staticRenderFns } from "./TransferUnit.vue?vue&type=template&id=fd7c50c0&"
import script from "./TransferUnit.vue?vue&type=script&lang=js&"
export * from "./TransferUnit.vue?vue&type=script&lang=js&"
import style0 from "./TransferUnit.vue?vue&type=style&index=0&id=fd7c50c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports